import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { map } from 'rxjs';

import { IncrementalStakesService } from './incremental-stakes.service';
import { NumpadUtilsService } from './numpad-utils.service';
import { NumpadService } from './numpad.service';

interface StakeModel {
    value: number;
    title: string;
}

@Component({
    selector: 'ms-incremental-stakes',
    templateUrl: './incremental-stakes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class IncrementalStakesComponent {
    private stakeValues$ = this.incrementalStakesService.getValues$().pipe(map((values) => values.map((v) => this.mapValue(v))));
    stakeValues = toSignal(this.stakeValues$, { initialValue: [] });

    constructor(
        private incrementalStakesService: IncrementalStakesService,
        private numpadService: NumpadService,
        private utils: NumpadUtilsService,
    ) {}

    addToStake(stakeToAdd: number): void {
        this.numpadService.increment(stakeToAdd);
    }

    private mapValue(value: number): StakeModel {
        return {
            value,
            title: `+${this.utils.toFormattedValue(String(value))}`,
        };
    }
}
